import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    formValues_a: {
      title: '【Q1】J-REIT個別銘柄に投資しない理由は？（複数回答可）',
      saveValue: [],
      nameProperty: 'entry.314342575',
      saveValueOther: '',
      namePropertyOther: 'entry.940612720',
      value: ['元本が保証されていない', '投資口価格（株価）の上昇が期待できない', '投資口価格（株価）の下落リスク', '時価総額・出来高が小さい', '投資対象が不動産だから',
        'REITの仕組みが分からない', 'REITの仕組みが信用できない', '個別銘柄の違いが分からない', 'スポンサーの信用力に欠ける', '利益相反の懸念', 'REIT市況の懸念',
        '不動産市況の懸念', '金利上昇の懸念', 'REIT組入れの投資信託・ETFに投資する', '資金不足', 'その他:']
    },
    formValues_b: {
      title: '【Q2】今後J-REITに投資したい？',
      requiredMark: '*必須',
      saveValue: '',
      nameProperty: 'entry.1785838515',
      value: ['REITの個別銘柄に投資したい', 'REIT組入れの投資信託・ETFに投資したい', '今後もREIT投資はしない']
    },
    formValues_c: {
      title: '【Q3】J-REITに投資するために何を望みますか？（複数回答可）',
      saveValue: [],
      nameProperty: 'entry.493920775',
      saveValueOther: '',
      namePropertyOther: 'entry.595592449',
      value: ['運用実績（トラックレコード）の積み上げ', '投資口価格（株価）の上昇', '投資口価格（株価）の安定', '分配金利回りの上昇（投資口価格の下落）', '1口当たり分配金の成長',
        '1口当たり分配金の安定', '時価総額の成長', '資産規模の拡大（外部成長）', '保有不動産の売却（含み益の実益化）', 'ポートフォリオの分散', '財務の安定性', '情報開示', 'スポンサーの信用力', '投資口分割', '自己投資口の取得', '再編（合併・スポンサー交代）',
        '海外不動産投資', 'ESGの取組み強化', 'IR活動の強化（WEB・個別説明・説明会開催等）', '特になし', 'その他:']
    },
    formValues_d: {
      title: '【Q4】J-REITについてご意見・ご質問ありましたらご自由にお書き下さい',
      saveValue: '',
      nameProperty: 'entry.705371002'
    },
    formValues_e: {
      title: '【Q5】当サイト「JAPAN-REIT.COM」についてご意見・ご質問ありましたらご自由にお書き下さい',
      saveValue: '',
      nameProperty: 'entry.1523112235'
    },
    formValues_f: {
      title: '性別',
      requiredMark: '*必須',
      saveValue: '',
      nameProperty: 'entry.1852767127',
      saveValueOther: '',
      namePropertyOther: 'entry.166888497',
      value: ['男性', '女性', '回答しない', 'その他:']
    },
    formValues_g: {
      title: '年齢',
      requiredMark: '*必須',
      saveValue: '',
      nameProperty: 'entry.887476509',
      value: ['20歳未満', '20～29歳', '30～39歳', '40～49歳', '50～59歳', '60～69歳', '70～79歳', '80歳以上', '回答しない']
    },
    formValues_host: {
      saveValue: '',
      nameProperty: 'entry.121667405'
    }
  },
  mutations: {
    setFormValues_a (state, payload) {
      state.formValues_a = payload.formValues_a
    },
    setFormValues_b (state, payload) {
      state.formValues_b = payload.formValues_b
    },
    setFormValues_c (state, payload) {
      state.formValues_c = payload.formValues_c
    },
    setFormValues_d (state, payload) {
      state.formValues_d = payload.formValues_d
    },
    setFormValues_e (state, payload) {
      state.formValues_e = payload.formValues_e
    },
    setFormValues_f (state, payload) {
      state.formValues_f = payload.formValues_f
    },
    setFormValues_g (state, payload) {
      state.formValues_g = payload.formValues_g
    },
    setFormValues_host (state, payload) {
      state.formValues_host = payload.formValues_host
    }
  },
  actions: {},
  modules: {}
})
